/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/bandList.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_BANDS } from "../graphql";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
export interface IBandSelectionListMethods extends IPluginMethodMap {
  getBandList(args: GetBandSelectionListProps): Promise<any>;
}

export interface GetBandSelectionListProps {}

export class GetBandSelectionListService implements IAgentPlugin {
  readonly methods?: IBandSelectionListMethods;
  private allSectionOptions: any = [];

  constructor() {
    this.methods = {
      getBandList: this.getBandList.bind(this),
    };
  }

  async getBandList(args: GetBandSelectionListProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_BANDS,
          variables: {},
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          return {
            ...config,
            isEmpty:
              res?.data?.getBandsWithSections?.content &&
              res?.data?.getBandsWithSections?.content.length === 0,
            lists: this._getAppCardList(
              res?.data?.getBandsWithSections?.content
            ),
            roles: res?.data?.getListOfRole?.data,
            metaData: {
              ...res?.data?.getMetadata,
              sectionOptTypes: this.allSectionOptions,
            },
          };
        }
      }
    } catch (err: any) {
      console.log(`error :`, err);
    }
  }

  private _getAppCardList = (data: any) => {
    let fistHalf: any[] = [];
    let _res: any[] = [];

    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any, index: number) => {
        if (item?.name.trim() !== "ROGUE - EPIC Carnival") {
          if (
            (item?.name && item?.name?.toLowerCase() === "tribe") ||
            (item?.name && item?.name?.toLowerCase() === "bliss") ||
            (item?.name && item?.name?.toLowerCase() === "harts")
          ) {
            fistHalf.push({
              key: item?.name && item?.name,
              title: item?.label,
              icon: item?.logo,
              name: item?.name,
              appCardId: item?.id && item?.id,
              appCardTitle: item?.label,
              sections: this._getSections(item?.sections),
            });
          } else {
            _res.push({
              key: item?.id && item?.id,
              title: item?.label,
              icon: item?.logo,
              name: item?.name,
              appCardId: item?.id && item?.id,
              appCardTitle: item?.label,
              sections: this._getSections(item?.sections),
            });
          }

          this._getSectionOptTypes(item?.sections);
        }
      });

    _res = [...fistHalf, ..._res];

    return _res;
  };

  private _getSections = (data: any) => {
    const allSections: any = [];

    data &&
      is.existy(data) &&
      is.not.empty(data) &&
      data.forEach((obj: any) => {
        if (
          obj?.name &&
          is.existy(obj?.name) &&
          !allSections.includes(obj?.name)
        ) {
          allSections.push(obj?.name);
        }
      });

    return allSections;
  };

  private _getSectionOptTypes = (data: any) => {
    data &&
      is.existy(data) &&
      is.not.empty(data) &&
      data.forEach((obj: any) => {
        if (
          obj?.sectionOptionType &&
          is.existy(obj?.sectionOptionType) &&
          is.not.empty(obj?.sectionOptionType)
        ) {
          obj?.sectionOptionType.forEach((item: any) => {
            if (
              item?.name &&
              is.existy(item?.name) &&
              !this.allSectionOptions.includes(item?.name)
            ) {
              this.allSectionOptions.push(item?.name);
            }
          });
        }
      });
  };
}
